import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import Image from '../../atoms/Image/Image'
import contactImage from '../../../assets/images/contactImage.jpg'
import InnerBanner from '../../molecules/InnerBanner/InnerBanner'
import Address from '../../templates/Address/Address'
import EmailAddress from '../../templates/EmailAddress/EmailAdress'
import PhoneNo from '../../templates/PhoneNo/PhoneNo'
import MapSection from '../../molecules/MapSection/MapSection'
import ContactForm from '../../molecules/Form/ContactForm'

const Contact = () => {
  return (
    <>
      <InnerBanner
        title="Get in Touch"
        subtitle="Tell us what you think"
        imageSrc={contactImage}
        imageAlt="Contact Banner"
      />

      <section className='information-details section-padding'>
        <Container>
          <Row>
            <Col className='col-12 col-lg-4 card border-0 mb-4 mb-lg-0 ' >
              <div className=' card-body information-details--item'>
                <Address />
              </div>
            </Col>
            <Col className='col-12 col-lg-4 card border-0 mb-4 mb-lg-0' >
              <div className=' card-body information-details--item'>
                <EmailAddress />
              </div>
            </Col>
            <Col className='col-12 col-lg-4 card border-0 mb-4 mb-lg-0' >
              <div className=' card-body information-details--item'>
                <PhoneNo />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className='contact-section section-padding-bottom'>
        <Container>
          <Row>
            <Col className='col-12 col-lg-6 mb-4 mb-lg-0'>
              <h2 className='h2'>Get In Touch</h2>
              <ContactForm />
            </Col>
            <Col className='col-12 col-lg-6'>
              <div className='contact-section--map'>
                <MapSection />
              </div>
            </Col>
          </Row>

        </Container>
      </section>



    </>
  )
}

export default Contact
